module.exports = __webpack_public_path__ + "media/images/gearguide-photo-05e402f36feed41d7b0dce42a63a4ef8.jpg";